import { render, staticRenderFns } from "./AnoFiscalForm.vue?vue&type=template&id=23448c57&lang=html&"
import script from "./AnoFiscalForm.vue?vue&type=script&lang=js&"
export * from "./AnoFiscalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/ano-fiscal/AnoFiscalForm.vue
// module id = 1046
// module chunks = 28